import React, {useEffect, useRef, useState} from "react";
import queryString from "query-string";
import {useHistory} from "react-router-dom";
import {isMobile} from "react-device-detect";
import environment from "../../environment";
import styles from "../ReferralPage/ReferralPage.module.css";
import logo from "../../img/taxefy_logo.png";
import * as qrcode from "qrcode";

export default function MagicLinkLoginPage() {
	const history = useHistory();

	const canvasRef = useRef(null);
	const qrCodeContainerRef = useRef(null);
	const [fallbackVisible, setFallbackVisible] = useState(false);

	function navigate(path) {
		window.location.replace(path);
	}

	const getLink = async () => {

		const parsed = queryString.parse(location.search);
		if (Object.keys(parsed).length && parsed.token) {
			if (isMobile) {
				if (environment?.country === "DE") {
					const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
					let deepLinkUrl = "";
					if (/android/i.test(userAgent)) {
						// Android-specific deep link
						deepLinkUrl = `de.taxefy.android://email-verification?token=${parsed.token}`;
					} else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
						// iOS-specific deep link
						deepLinkUrl = `de.taxefy.app://email-verification?token=${parsed.token}`;
					}
					if (deepLinkUrl) {
						navigate(deepLinkUrl);
						setTimeout(() => {
							history.push("/auth/login");
						}, 100);
					}
				} else {
					navigate(`at.taxefy.app://email-verification?token=${parsed.token}`);
					setTimeout(() => {
						history.push("/auth/login");
					}, 100);
				}
			}
			if (!isMobile) {
				const canvas = canvasRef.current;

				const options = {
					width: 300,
					margin: 2,
					color: {
						dark: "#000000", // QR code color
						light: "#FFFFFF", // Background color
					},
				};

				await qrcode.toCanvas(canvas, `at.taxefy.app://email-verification?token=${parsed.token}`, options);
			}
		}
	};

	useEffect(() => {
		getLink();
		if (isMobile) {
			setTimeout(() => {
				setFallbackVisible(true);
			}, 1500);
		}
	}, []);

	return (
		<div className={styles["container"]}>
			<header>
				<img src={logo} alt="logo" className={styles["logo"]} />
			</header>

			<main className={styles["main"]}>
				<div>
					<h1 className={styles["title"]}>📲 Schnell einscannen & sofort starten!</h1>
					<h2 className={styles["description"]}>
						Scanne den QR-Code mit deinem Handy, um deine Steuererstattung zu sichern – im Schnitt 1.000 € zurück! 💰🚀
					</h2>

					{isMobile && fallbackVisible && (
						<p className={styles["fallback"]}>
							Wenn die App nicht automatisch geöffnet wurde, bitte{" "}
							<a href={`${environment.baseUrl}fallback`} className={styles["link"]}>
								klicke hier
							</a>
							.
						</p>
					)}

					{/* Animated QR Code */}
					{!isMobile && (
						<div
							ref={qrCodeContainerRef}
							className={styles["qr-container"]}
						>
							<canvas ref={canvasRef} className={styles["qr-canvas"]} />
							<div className={styles["qr-overlay"]}></div>
						</div>
					)}
				</div>
			</main>

			<footer></footer>
		</div>
	);
}
